import React, {Component} from "react"
import styled from "styled-components"
import {findIndex} from "lodash"

import {User, Team, TeamState} from "@irati/types"
import {QueryUsersArgs} from "@irati/identity/services/queries/usersForBusiness"
import History from "@irati/utils/history"
import adminTracking from "@irati-tracking/admin"

import managerOfTeamLabel from "@irati/identity/helpers/user/managerOfTeamLabel"
import UserComponent, {UserViewButton} from "../User"
import UserFilter from "../UserFilter"

export const StyledUser = styled(UserComponent)`
  .user_lastname {
    ${(props) => (props.boldLastname ? "font-weight: bold;" : "")}
  }
`

interface Props {
  employees: User[]
  selectedEmployees: User[]
  onToggle: () => void
  onToggleAll: () => void
  onUpdate: () => void
  variables: QueryUsersArgs
  businessUnits: Team[]
}

interface State {
  selectedUser: User | null
}

export class UserList extends Component<Props, State> {
  static defaultProps = {
    className: null
  }

  userPopup = React.createRef<any>()

  state: State = {
    selectedUser: null
  }

  getUserTeams = (user: User) => {
    if (user.teams?.results) {
      const sortedArr = [...user.teams?.results]
      sortedArr.sort((a, b) => {
        if (a.teamName < b.teamName) {
          return -1
        }
        if (a.teamName > b.teamName) {
          return 1
        }
        return 0
      })
      return sortedArr
        .map((team) => {
          if (team.teamState === TeamState.Generic) {
            return managerOfTeamLabel(team, user)
          }
        })
        .filter((t) => !!t)
        .join(", ")
    }
    return null
  }

  getBusinessUnit = (user: User): Team | undefined => {
    const {businessUnits} = this.props
    const businessUnit = businessUnits.find((team) => user.teamIds.find((userTeamUuid) => userTeamUuid === team.uuid))
    return businessUnit
  }

  action = (user: User) => {
    return <UserViewButton user={user} onButtonClick={this.openModal} />
  }

  openModal = (user: User) => {
    adminTracking.viewUser()
    History.push({pathname: `/admin/people/edit/${user.uuid}`})
  }

  render() {
    const {employees, selectedEmployees, onToggle, onToggleAll, businessUnits} = this.props

    return (
      <div>
        <UserFilter
          key="headerUser"
          onToggleAll={onToggleAll}
          checked={selectedEmployees.length === employees.length}
          hideBusinessUnit={!(businessUnits && businessUnits.length > 0)}
        />
        {employees.map((user) => (
          <StyledUser
            key={user.uuid}
            user={user}
            rowData={this.getUserTeams(user)}
            businessUnit={this.getBusinessUnit(user)}
            boldLastname={false}
            onToggle={onToggle}
            checked={findIndex(selectedEmployees, (test) => test.uuid === user.uuid) > -1}
            action={this.action(user)}
          />
        ))}
      </div>
    )
  }
}

export default UserList
